var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var ArrowRightThin = function ArrowRightThin(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 6 14' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { id: 'Dark-Breadcrumb-Arrow', d: 'M.8 0L0 .7 4.6 7 0 13.3l.8.7L6 7z' })
    )
  );
};
/*eslint-enable */

export default ArrowRightThin;
//# sourceMappingURL=ArrowRightThin.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/ArrowRightThin.js